export interface PreviewItem {
  image: string
  alt: string
  caption: string
}

export const previewItems: PreviewItem[] = [
  {
    image: 'https://cdn.magicpatterns.com/uploads/hhL3S56HpgsYbWKLoxx9TL/Captura_de_pantalla_2026-09-12_a_la(s)_8.48.42_p._m..png',
    alt: 'Pagina con due schede di esercizio dell’Unità 1, con obiettivo motorio, svolgimento e varianti',
    caption: 'Scheda di esercizio',
  },
  {
    image: 'https://cdn.magicpatterns.com/uploads/1Utev84WXgaJN1XZcz49jb/Captura_de_pantalla_2026-09-12_a_la(s)_8.50.37_p._m..png',
    alt: 'Unità didattica completa con schede illustrate, voce del docente e varianti inclusive',
    caption: 'Unità didattica completa',
  },
  {
    image: 'https://cdn.magicpatterns.com/uploads/tcACw5zXd188G6WpxXSbjA/Captura_de_pantalla_2026-09-12_a_la(s)_8.48.53_p._m..png',
    alt: 'Griglia di osservazione annuale, rubrica a 4 livelli e descrittori dal 4 al 10',
    caption: 'Griglia di valutazione',
  },
  {
    image: 'https://cdn.magicpatterns.com/uploads/tf3it8F1HarKt7HoCresNh/Captura_de_pantalla_2026-09-12_a_la(s)_8.53.02_p._m..png',
    alt: 'Schede con giochi finali dell’Unità 1: il cerchio magico delle parti e il disegno del corpo',
    caption: 'Gioco finale',
  },
  {
    image: 'https://cdn.magicpatterns.com/uploads/r36oSBVT8tX96dLGqRsQ6P/Captura_de_pantalla_2026-09-12_a_la(s)_8.49.04_p._m..png',
    alt: 'Pianificazione settimana per settimana su 33 settimane con distribuzione dei nuclei curricolari',
    caption: 'Progressione per età',
  },
  {
    image: 'https://cdn.magicpatterns.com/uploads/u5R3ph1pGzxuopsZE3YYdr/Captura_de_pantalla_2026-09-12_a_la(s)_8.51.38_p._m..png',
    alt: 'Pagina bonus con la scheda del palleggio sopra la testa e il livello specialista',
    caption: 'Pagina bonus',
  },
]
